<script lang="ts" setup>
import { ref } from 'vue'
import { Plus } from '@element-plus/icons-vue'
import OrganizationDialog from '@/components/dialogs/OrganizationDialog.vue'

interface Props {
    size?: number
    tooltipDisabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    tooltipDisabled: false,
    size: 40
})

const showDialog = ref(false)
</script>

<template>
    <el-tooltip class="box-item" effect="dark" content="Create Organization" placement="right">
        <el-avatar @click="showDialog = true" class="mr-3" shape="square" :size="props.size - 3">
            <div class="imageFallback" :style="{ fontSize: props.size - 10 }">
                <el-icon :size="20">
                    <Plus />
                </el-icon>
            </div>
        </el-avatar>
    </el-tooltip>
    <OrganizationDialog v-model="showDialog" />
</template>

<style lang="scss" scoped>
.el-avatar {
    margin: auto;
    color: var(--el-text-color-primary);
    background-color: var(--el-bg-color-page);

    .imageFallback {
        width: 100%;
        height: 100%;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        text-transform: capitalize;
    }

    &:hover {
        margin: auto;
        background-color: var(--el-border-color);
    }
}
</style>
